/* Component Dependencies */
var $ = require('jquery');
var crossLinksTemplate = require('templates/hotelDirectoryCrossLinks.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'hotelDirectoryCrossLinks',
  template: {
    'hotelDirectoryCrossLinks': crossLinksTemplate
  },
  // This variable is moved here so that it can be updated globally whenever screen is rotated(portrait/landscape mode)
  windowWidth: $(window).width(),
  bindEvents: function () {
    var _self = this,
      $window = $(window),
      $panelHeading = _self.$el.find('.panel-heading');

    $window.on('load resize', function (event) {
      _self.resizeHandler($window, $panelHeading, event);
    });
  },
  subscribe: {
    'TOGGLE_HOTEL_DIRECTORY_CROSS_LINKS': 'toggleHotelDirectoryCrossLink'
  },

  /**
   * This method is used handle the click event on the panel haeding and
   * to toggle the panel list items.
   * @return {Void}
   */
  listClickHandler: function listClickHandler(elem) {
    elem.off('click').on('click', function () {
      var $this = $(this),
        isExpanded = $this.find('.panel-icon').hasClass('icon-drawer-open');

      $this.next('.panel-body').slideToggle('slow');
      $this.find('.panel-icon').toggleClass('icon-drawer-open icon-drawer-close')
      $this.find('.t-caption-icon').toggleClass('t-icon-arrow-down t-icon-arrow-up').end()
        .find('.panel-title').attr('aria-expanded', isExpanded);

    });
  },

  /**
   * This method is called on resizing the window and modifies the view of the cross-section
   * based on the screen size.
   * @return {Void}
   */
  resizeHandler: function resizeHandler(window, heading, event) {
    //This change has been added for iphone view. Scrolling was zooming the url address bar so resizing the screen.
    //Preventing false resize event like this.
    if (event.type === "resize" && this.windowWidth === window.width())
      return true;
    this.windowWidth = window.width();
    if (window.width() < 600) {
      if (event.type === "load") {
        heading.next('.panel-body').hide().end()
          .find('.panel-icon').removeClass('icon-drawer-close').addClass('icon-drawer-open');
      }
      else if (event.type === "resize") {
        heading.find('.l-toggle-list').show();
        heading.next('.panel-body').hide();
        heading.find('.panel-icon.icon-drawer-close').parents('.panel-heading').next('.panel-body').show();
      }
      this.listClickHandler(heading);
    } else {
      heading.find('.l-toggle-list').hide();
      heading.off('click');
      heading.next('.panel-body').show();
    }
  },
  toggleHotelDirectoryCrossLink: function _toggleHotelDirectoryCrossLink(isTileDisplayed) {
    var _self = this;
    isTileDisplayed === true ? _self.$el.removeClass('l-display-none').addClass('l-display-block') : _self.$el.removeClass('l-display-block').addClass('l-display-none');
  }
});
